import { NavigationPathsEnum } from "@utilities/enums";
import { useNavigation } from "@utilities/hooks";

export const useController = () => {

    const { navigateTo } = useNavigation();

    const stockMenu = [
        {
            label: 'Ajouter un nouvel article',
            link: NavigationPathsEnum.ADD_ARTICLE,
            icon: "Plus",
            classname: "bg-primary text-primary-content"
        },
        {
            label: 'Gestion des articles',
            link: NavigationPathsEnum.MANAGE_ARTICLE,
            icon: 'ChartNoAxesGantt',
            classname: "bg-secondary text-secondary-content"
        },
        {
            label: 'Gestion des ventes',
            link: NavigationPathsEnum.SELLING_MANAGEMENT,
            icon: 'TextSelect',
            classname: "bg-info text-info-content"
        },
        {
            label: 'Gestion des inventaires',
            link: NavigationPathsEnum.INVENTORY_MANAGEMENT,
            icon: 'ClipboardList',
            classname: "bg-warning text-warning-content"
        },
        {
            label: 'Gestion des promotions/remises',
            link: NavigationPathsEnum.PROMOTION_MANAGEMENT,
            icon: 'Percent',
            classname: "bg-error text-error-content"
        },
        {
            label: 'Gestion des credits',
            link: NavigationPathsEnum.CREDITS_MANAGEMENT,
            icon: 'HandCoins',
            classname: "bg-primary text-primary-content"
        },
        {
            label: 'Gestion des clients',
            link: NavigationPathsEnum.CLIENTS_MANAGEMENT,
            icon: 'Users',
            classname: "bg-secondary text-secondary-content"
        },
    ];

    return { stockMenu, navigateTo }
}
